<template>
  <section id="table-users">
    <b-overlay :show="showContent" spinner-variant="primary" variant="transparent" blur="3px" rounded="sm">
      <b-card no-body>
        <b-table striped hover responsive class="position-relative" :current-page="usersTable.currentPage"
          :items="usersTable.items" :fields="usersTable.fields" :sort-by.sync="usersTable.sortBy"
          :sort-desc.sync="usersTable.sortDesc" :sort-direction="usersTable.sortDirection" :filter="usersTable.filter"
          :filter-included-fields="usersTable.filterOn" @row-clicked="rowClicked">
          <template #cell(hub_names)="data">
            <b-badge v-for="item in data.value" :key="item.id" variant="light-primary">
              {{ item.name }}
            </b-badge>
          </template>
        </b-table>

        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <!-- pagination -->
          <div>
            <b-pagination v-model="usersTable.currentPage" :total-rows="usersTable.totalRows" first-number last-number
              prev-class="prev-item" next-class="next-item" class="mb-0" @change="handlePageChange">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :to="{ name: 'create-user' }">
            Create User
          </b-button>
        </b-card-body>
      </b-card>
    </b-overlay>
  </section>
</template>

<script>
import {
  BCard,
  BTable,
  BBadge,
  BPagination,
  BButton,
  BCardBody,
  BOverlay,
} from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import axios from "axios"

export default {
  components: {
    BCard,
    BTable,
    BBadge,
    BPagination,
    BButton,
    BCardBody,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showContent: true,
      usersTable: {
        totalRows: 1,
        currentPage: 1,
        sortBy: "date_joined",
        sortDesc: true,
        sortDirection: "desc",
        filter: null,
        filterOn: [],
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        fields: [
          { key: "username", label: "username", sortable: true },
          { key: "email", label: "email", sortable: true },
          { key: "hub_names", label: "hubs", sortable: true },
          {
            key: "date_joined",
            label: "Date joined",
            sortable: true,
            formatter: value => {
              let new_date = new Date(value)
              if (value) {
                return new_date.toLocaleString("de-DE", {
                  timeZone: "Europe/Berlin"
                })
              }
              else {
                return ""
              }
            }
          },
        ],
        /* eslint-disable global-require */
        items: [],
        queryParams: {},
      },
    }
  },
  methods: {
    rowClicked(row) {
      this.$router.push({ name: "user-details", params: { id: row["id"] } })
    },
    async getUsers() {
      await axios
        .get(process.env.VUE_APP_ROOT_API + "/users/", {
          headers: {
            "Authorization": `JWT ${this.$store.state.jwt}`,
            "Content-Type": "application/json"
          },
          params: this.queryParams,
        })
        .then(response => {
          this.usersTable.items = response.data.results
          this.usersTable.totalRows = response.data.count * 2
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$router.push({ name: "login" })
          }
          else if (error.response.status == 403) {
            this.$router.push({ name: "home" })
          }
        })
    },
    async handlePageChange(value) {
      this.showContent = true
      this.queryParams["page"] = value
      await this.getUsers()
      this.showContent = false
    }
  },
  async created() {
    this.showContent = true
    Promise.all([
      await this.getUsers()
    ]).finally(() => {
      this.showContent = false
    })
  }
}
</script>
